import { createContext, useContext } from "react";
import type { useScrollSnap } from "../../../../../../../common-deprecated/hooks/useScrollSnap";

type ContextType = {
    carouselProperties: (ReturnType<typeof useScrollSnap> & { sliderDisabled: boolean }) | null;
    setCarouselProperties: (properties: ReturnType<typeof useScrollSnap> & { sliderDisabled: boolean }) => void;
};

export const CarouselContext = createContext<ContextType>({
    carouselProperties: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCarouselProperties: () => {},
});

export const useCarouselContext = (): ContextType => {
    const context = useContext(CarouselContext);

    if (context === null) {
        throw new Error("Carousel must be wrapped inside a context provider");
    }

    return context;
};
